import { isExistFeatureFlag } from '@/service/feature/isExistFeatureFlag';
import { isBetaFacility } from '@/service/facility/isBetaFacility';

const FEATURE_KEY = 'strict_administrator_password_policy';

// サーバー側バリデーション（administrators/update.php 等の FeatureAvailability）と同じ判定。
// feature_flags への全体登録 または ログイン施設の beta_facilities 登録のどちらかで有効になる。
export const isStrictPasswordPolicyEnabled = async (): Promise<boolean> => {
  const [hasFlag, isBeta] = await Promise.all([isExistFeatureFlag(FEATURE_KEY), isBetaFacility(FEATURE_KEY)]);
  return hasFlag || isBeta;
};
